<template>
  <div class="shop-product-wrap grid">
     <template v-for="product in products">
        <product-item :product= "product" ></product-item>
      </template>
  </div>
</template>

<script>
  import ProductItem from './ProductItem.vue'
  export default {
    name: 'product-list',
    props: ['products'],
    components: {
      'product-item': ProductItem
    },
    mounted () {

    },
    methods: {
       navBack () {
         console.log ("navigate back");
         this.$router.go (-1);
       }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/products/ProductList.vue